<template>
  <div class="loading-img">
    <span>Loading...</span>
    <img src="./../assets/images/loading.svg" alt="Loading..." />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loading-img {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 2rem;
  flex-direction: column-reverse;
}

span {
  margin-top: -1rem;
  position: relative;
}

img {
  width: 12rem;
}
</style>
